/* ============================================================================
   DRB sheet — a link inside a marked section opens a panel instead of leaving

   Markup and the whole rationale live in snippets/drb-sheet.liquid.

   ⚠️ GUARDED, BECAUSE TWO SECTIONS ON ONE PAGE EACH EMIT THIS TAG. Duplicate
   <script src> tags for the same URL are fetched once and EXECUTED twice, so
   without the flag the Gut Health PDP — which renders panels from both the
   buy box and the biotics section — would bind two identical delegated
   listeners and open, then immediately reopen, every panel. Same guard the
   biotics tab script already uses, for the same reason.
   ============================================================================ */
(function () {
  if (window.__drbSheet) return;
  window.__drbSheet = true;

  /* Compared as a path, not as a string. The setting stores "/pages/x" while
     an author may well paste a full URL, and either side can pick up a
     trailing slash without the two meaning anything different. */
  function toPath(value) {
    if (!value) return null;
    try {
      return new URL(value, window.location.href).pathname.replace(/\/+$/, '');
    } catch (e) {
      return null;
    }
  }

  document.addEventListener('click', function (event) {
    var closer = event.target.closest('[data-drb-sheet-close]');
    if (closer) {
      var owner = closer.closest('dialog');
      if (owner) owner.close();
      return;
    }

    /* The dialog element fills the viewport while its own box does not, so a
       click that lands ON the dialog rather than inside it is a backdrop
       click. */
    var panel = event.target.closest('[data-drb-sheet]');
    if (panel && event.target === panel) {
      panel.close();
      return;
    }

    var link = event.target.closest('a[href]');
    if (!link) return;

    /* ⚠️ THE PANEL'S OWN WAY OUT POINTS AT THE SAME URL. Without this the
       footer link would match its own panel and reopen it. */
    if (link.closest('.drb-sheet')) return;

    /* Opt-in per section: an unmarked link anywhere else on the page — the
       nav, the footer, a related-pages row — still navigates, which is what
       those are for. */
    var scope = link.closest('[data-drb-sheet-scope]');
    if (!scope) return;

    /* A modified click is a deliberate request for a new tab or a window. */
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    var target = toPath(link.getAttribute('href'));
    if (!target) return;

    var panels = Array.prototype.slice.call(scope.querySelectorAll('[data-drb-sheet]'));
    var match = null;
    for (var i = 0; i < panels.length; i++) {
      if (toPath(panels[i].getAttribute('data-path')) === target) {
        match = panels[i];
        break;
      }
    }

    /* ⛔ preventDefault RUNS LAST, AFTER EVERY REASON NOT TO. The URL had to
       parse, a panel had to exist for it, and the browser has to support
       showModal. Any one of those failing falls through to the anchor's own
       behaviour and the reader still gets the page — a panel that swallows
       the click and then cannot open is worse than no panel at all. */
    if (!match || typeof match.showModal !== 'function') return;

    event.preventDefault();
    match.showModal();
  });
})();
